export const SMaskedInputOverrides = (error, hasEndEnhancer = false) => ({
  Root: {
    style: ({ $theme }) => ({
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error ? 'transparent' : $theme.colors.white,
      paddingRight: hasEndEnhancer ? '0' : undefined,
    }),
  },
  Input: {
    style: ({ $theme, $disabled }) => ({
      color: $theme.colors.black,
      fontSize: '16px',
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      paddingBottom: '.125rem',
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error || $disabled ? 'transparent' : $theme.colors.white,
    }),
  },
  InputContainer: {
    style: {
      paddingTop: '0.625rem',
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: '0.625rem',
      paddingLeft: '4px',
      paddingRight: '8px',
      paddingBottom: '0',
      backgroundColor: error ? 'transparent' : '',
    },
  },
})
